import { render, staticRenderFns } from "./orderPl.vue?vue&type=template&id=653a0b7e&scoped=true"
import script from "./orderPl.vue?vue&type=script&lang=js"
export * from "./orderPl.vue?vue&type=script&lang=js"
import style0 from "./orderPl.vue?vue&type=style&index=0&id=653a0b7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a0b7e",
  null
  
)

export default component.exports